import { on, off } from './dom';
import { Config, getRouteChangeEventIsWrapped, setRouteChangeEventWrapped, ROUTE_MODE, getInnerEventName } from './config';
var win = typeof window !== 'undefined' && window;
var doc = win && document;

/**
  * 路由监听
  *
  * @function
  * @param {Function} handler 路由切换的时候的回调函数
  */
var onRouteChange = function onRouteChange(handler) {
  // eslint-disable-next-line no-empty-function
  handler = typeof handler === 'function' ? handler : function () {};
  var observeHandler = function observeHandler() {
    handler.apply(void 0, arguments);
  };
  var restoreFns = [];
  if (Config.ROUTE_MODE !== ROUTE_MODE.SERVER) {
    if (Config.ROUTE_MODE === ROUTE_MODE.HASH) {
      on(win, 'hashchange', observeHandler);
      restoreFns.push(function () {
        return off(win, 'hashchange', observeHandler);
      });
    } else {
      if (!getRouteChangeEventIsWrapped()) {
        var patchedUpdateState = function patchedUpdateState(updateState, methodName) {
          setRouteChangeEventWrapped();
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var returnValue = updateState.apply(history, args);
            var event = doc.createEvent('Event');
            event.initEvent(methodName.toLowerCase(), true, true);
            event.habo = true;
            event.haboTrigger = methodName;
            event.arguments = args;
            win.dispatchEvent(event);
            return returnValue;
          };
        };
        history.pushState = patchedUpdateState(win.history.pushState, getInnerEventName('pushstate'));
        history.replaceState = patchedUpdateState(win.history.replaceState, getInnerEventName('replacestate'));
      }
      on(win, 'popstate', observeHandler);
      on(win, getInnerEventName('pushstate'), observeHandler);
      on(win, getInnerEventName('replacestate'), observeHandler);
      restoreFns.push(function () {
        return off(win, 'popstate', observeHandler);
      });
      restoreFns.push(function () {
        return off(win, getInnerEventName('pushstate'), observeHandler);
      });
      restoreFns.push(function () {
        return off(win, getInnerEventName('replacestate'), observeHandler);
      });
    }
  }
  var tearDown = function tearDown() {
    restoreFns.forEach(function (fn) {
      return fn();
    });
    restoreFns.length = 0;
  };
  return tearDown;
};
export default onRouteChange;